import script from "./ComplaintEmailTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintEmailTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintEmailTemplate.vue?vue&type=style&index=0&id=cdac9a9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdac9a9c"]])

export default __exports__